import { RouteObject } from 'react-router';

import { OrderModuleRoutes } from './modules/order';
import { ProductModuleRoutes } from './modules/product';

export const routes: RouteObject[] = [...OrderModuleRoutes, ...ProductModuleRoutes];
